import { inject, injectable } from "inversify";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { DirectDebitCollectionDayModel, ICPLDirectDebitCollectionDaysClient } from "./api/cplapi/CPLAPI";

export interface IDirectDebitCollectionDaysService {
  getDirectDebitCollectionDays(): Promise<DirectDebitCollectionDayModel[]>;
  updateAllowedCollectionDays(allowedDays: number[]): Promise<void>;
}

@injectable()
export class DirectDebitCollectionDaysService implements IDirectDebitCollectionDaysService {
  @inject(SERVICE_TYPES.CPLDirectDebitCollectionDaysClient)
  cplDirectDebitCollectionDaysClient!: ICPLDirectDebitCollectionDaysClient;

  async getDirectDebitCollectionDays(): Promise<DirectDebitCollectionDayModel[]> {
    return this.cplDirectDebitCollectionDaysClient.getDirectDebitCollectionDays();
  }

  async updateAllowedCollectionDays(allowedDays: number[]): Promise<void> {
    return this.cplDirectDebitCollectionDaysClient.updateAllowedCollectionDays(allowedDays);
  }
}
